import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, SearchField, Badge, Button, ProgressBar } from '@getpay93/ui';
import { useClients, useMePlan } from '../../data/hooks';

function statusTone(s: string): 'paid' | 'pending' | 'overdue' | 'neutral' {
  if (s === 'active') return 'paid';
  if (s === 'paused') return 'pending';
  return 'neutral';
}

export function Miembros() {
  const [search, setSearch] = useState('');
  const clients = useClients({ search: search || undefined });
  const plan = useMePlan();
  const atLimit = plan.data ? plan.data.activeClients >= plan.data.effectiveFreeLimit && plan.data.effectiveTier === 'free' : false;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {plan.data && plan.data.effectiveTier === 'free' ? (
        <Card padding={14} style={atLimit ? { borderColor: 'var(--status-overdue)' } : undefined}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ color: 'var(--text-body)', fontWeight: 700 }}>Plan Gratis</span>
            <span style={{ color: 'var(--text-hint)' }}>{plan.data.activeClients} / {plan.data.effectiveFreeLimit}{plan.data.bonusFreeSlots ? ` (+${plan.data.bonusFreeSlots} bonus)` : ''}</span>
          </div>
          <ProgressBar value={plan.data.activeClients} max={plan.data.effectiveFreeLimit} height={6} tone={atLimit ? 'red' : 'green'} />
          {atLimit ? <p style={{ margin: '10px 0 0', fontSize: 13, color: 'var(--status-overdue)' }}>Llegaste al límite. Mejora tu plan para agregar más.</p> : null}
        </Card>
      ) : null}

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ flex: 1 }}><SearchField placeholder="Buscar cliente…" value={search} onChange={(e) => setSearch(e.currentTarget.value)} /></div>
        <Link to="/app/clientes/invitar"><Button iconLeft="plus">Invitar</Button></Link>
      </div>

      <Card padding={0}>
        {clients.isLoading ? <p style={{ padding: 16, color: 'var(--text-hint)' }}>Cargando…</p> : null}
        {clients.data && clients.data.length === 0 ? <p style={{ padding: 16, color: 'var(--text-hint)' }}>Sin clientes todavía.</p> : null}
        {(clients.data ?? []).map((c) => (
          <Link key={c.id} to={`/app/clientes/${c.id}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', borderBottom: '1px solid var(--border)' }}>
            <div>
              <div style={{ fontWeight: 700, color: 'var(--text-strong)' }}>{c.name}</div>
              <div style={{ fontSize: 13, color: 'var(--text-hint)' }}>{c.email ?? c.phone ?? ''}</div>
            </div>
            <Badge tone={statusTone(c.status)}>{c.status}</Badge>
          </Link>
        ))}
      </Card>
    </div>
  );
}
